(function () {
  if (window.__miyabiyaCookieConsentFix) return;
  window.__miyabiyaCookieConsentFix = true;

  var choiceKey = 'miyabiya_cookie_consent_choice';
  var consentButtonLabels = {
    accept: true,
    decline: false,
    deny: false,
  };

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getNodeText(node) {
    if (!node || node.nodeType !== 1) return '';
    if ('value' in node && node.value) return String(node.value);
    return node.innerText || node.textContent || '';
  }

  function getClickableFromPath(path) {
    for (var index = 0; index < path.length; index += 1) {
      var node = path[index];
      if (!node || node.nodeType !== 1 || !node.matches) continue;
      if (node.matches('button, a, input[type="button"], input[type="submit"], [role="button"]')) {
        return node;
      }
    }
    return null;
  }

  function getAncestorNodes(node) {
    var ancestors = [];
    var current = node;

    while (current) {
      ancestors.push(current);
      current = current.parentNode || current.host || null;
    }

    return ancestors;
  }

  function isCookieBannerText(text) {
    return (
      text.indexOf('cookie consent') !== -1 &&
      text.indexOf('privacy policy') !== -1 &&
      (text.indexOf('manage preferences') !== -1 || text.indexOf('accept') !== -1 || text.indexOf('decline') !== -1)
    );
  }

  function isCookieBannerPath(path) {
    return path.some(function (node) {
      var text = normalize(getNodeText(node));
      return isCookieBannerText(text);
    });
  }

  function rememberChoice(accepted) {
    try {
      window.localStorage.setItem(choiceKey, accepted ? 'accept' : 'decline');
    } catch (error) {
      // Ignore storage restrictions; the visible banner can still be closed.
    }
  }

  function syncShopifyConsent(accepted) {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') return;

    var consent = {
      analytics: accepted,
      marketing: accepted,
      preferences: accepted,
      sale_of_data: accepted,
    };

    try {
      customerPrivacy.setTrackingConsent(consent, function () {});
    } catch (firstError) {
      try {
        customerPrivacy.setTrackingConsent(accepted, function () {});
      } catch (secondError) {
        // Shopify can change this API shape. Closing the banner remains the fallback.
      }
    }
  }

  function hideElement(element) {
    if (!element || element.nodeType !== 1 || element === document.documentElement || element === document.body) {
      return;
    }
    element.setAttribute('data-miyabiya-cookie-hidden', 'true');
    element.setAttribute('aria-hidden', 'true');
    element.style.setProperty('display', 'none', 'important');
    element.style.setProperty('visibility', 'hidden', 'important');
    element.style.setProperty('pointer-events', 'none', 'important');
    element.style.setProperty('opacity', '0', 'important');
  }

  function hideCookieBannerFromNodes(nodes) {
    for (var index = 0; index < nodes.length; index += 1) {
      var node = nodes[index];
      var text = normalize(getNodeText(node));
      if (isCookieBannerText(text)) {
        hideElement(node);
        return true;
      }
    }
    return false;
  }

  function findCookieBanners(root) {
    var matches = [];
    if (!root || !root.querySelectorAll) return matches;

    root.querySelectorAll('div, section, aside, dialog, form').forEach(function (node) {
      var text = normalize(getNodeText(node));
      if (isCookieBannerText(text)) {
        matches.push(node);
      }
    });

    root.querySelectorAll('*').forEach(function (node) {
      if (node.shadowRoot) {
        matches = matches.concat(findCookieBanners(node.shadowRoot));
      }
    });

    return matches;
  }

  function hideVisibleCookieBanners() {
    findCookieBanners(document).forEach(hideElement);
  }

  function hasRememberedChoice() {
    try {
      if (window.localStorage.getItem(choiceKey)) return true;
    } catch (error) {
      // Ignore storage restrictions.
    }

    try {
      return document.cookie.indexOf('_tracking_consent=') !== -1;
    } catch (error) {
      return false;
    }
  }

  function scheduleHidePasses(nodes) {
    hideCookieBannerFromNodes(nodes);
    hideVisibleCookieBanners();

    [80, 250, 500, 1000, 1800].forEach(function (delay) {
      window.setTimeout(function () {
        hideCookieBannerFromNodes(nodes);
        hideVisibleCookieBanners();
      }, delay);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
      var clickable = getClickableFromPath(path);
      if (!clickable) return;

      var label = normalize(getNodeText(clickable));
      if (!(label in consentButtonLabels)) return;

      var nodesToInspect = path.length ? path.slice() : [];
      getAncestorNodes(clickable).forEach(function (node) {
        if (nodesToInspect.indexOf(node) === -1) nodesToInspect.push(node);
      });
      if (!isCookieBannerPath(nodesToInspect)) return;

      var accepted = consentButtonLabels[label];
      rememberChoice(accepted);
      syncShopifyConsent(accepted);
      scheduleHidePasses(nodesToInspect);
    },
    true
  );

  var observer = new MutationObserver(function () {
    if (hasRememberedChoice()) {
      hideVisibleCookieBanners();
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  try {
    if (hasRememberedChoice()) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', hideVisibleCookieBanners, { once: true });
      } else {
        hideVisibleCookieBanners();
      }
    }
  } catch (error) {
    // localStorage can be unavailable in strict browser modes.
  }
})();
